// extracted by mini-css-extract-plugin
export default {"table":"table__wCBhaNAA","lastUpdated":"lastUpdated__UnsGOp_H","tooltip":"tooltip__cZfQ9a7C","actionsWrapper":"actionsWrapper__AAJbpBH1"};